import { getAuthKey } from "./storage/browserStorage";

// Function arguments are references in the function, change them there too when changing them here.
const call = function(route, callback, onerror, headers, bodyInfo) {
    fetch(route.url, {
        method: route.method,
        credentials: "same-origin",
        body: bodyInfo ? bodyInfo.body : undefined,
        headers: {
            "Content-Type": bodyInfo ? bodyInfo.contentType : undefined,
            ...(headers || {})
        }
    }).then(resp => {
        if (resp.status < 400) {
            resp.json()
                .then(json => {
                    try {
                        callback(json, resp.status)
                    } catch (ignored) {}
                })
                .catch(e => callback({}, resp.status));
        } else {
            resp.json()
                .then(json => onerror(json, resp.status))
                .catch(e => onerror(resp, resp.status))
        }
    }).catch(err => {
        if (window.console) {
            console.error("Error: " + err)
        }
        onerror(err)
    });
}

export const messagesFetch = function(lang, callback, onerror){
    const route = mainRoutes.controllers.HomeController.getMessages(lang);
    call(route, callback, onerror)
}

export const createTable = function(config, callback, onerror){
    const route = mainRoutes.controllers.TableController.createTable();
    call(route, callback, onerror, undefined, { body: JSON.stringify(config), contentType: "application/json" })
}

export const getPublicTables = function(callback, onerror){
    const route = mainRoutes.controllers.TableController.getPublicTables();
    call(route, callback, onerror)
}

export const joinTable = function(code, name, callback, onerror){
    const route = mainRoutes.controllers.TableController.joinTable(code, name);
    call(route, callback, onerror)
}

export const getConnectToTableURL = function(code, playerKey) {
    const secure = document.location.protocol.startsWith("https") ? true : false
    const url = mainRoutes.controllers.TableController.connectToTable(code, playerKey).webSocketURL(secure);
    return url.replace(/doko-backend/g, document.location.host)
}

const headers = opts => ({ "Authorization": "Key " + getAuthKey(), ...(opts || {}) })

